var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, InputText, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { facebookMessengerApi } from 'apis/facebookMessenger';
import { QueueSelect } from 'components/queueSelect';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { createAppModal } from 'utils/modal';
import styles from './facebookEditPageModal.module.scss';
/** Represents the modal for editing the name and queue of a facebook page */
export const FacebookEditPageModal = createAppModal({ type: 'settings:editFacebookPage' }, ({ isOpen, modal, hide }) => {
    const notify = useNotifications();
    const [pageName, setPageName] = useState();
    const [selectedQueue, setSelectedQueue] = useState();
    const [updateFacebook, { isLoading }] = facebookMessengerApi.useUpdateFacebookPageMutation();
    const { facebookPage, searchQueue } = modal.arg;
    useEffect(() => {
        setPageName((facebookPage === null || facebookPage === void 0 ? void 0 : facebookPage.name) || '');
        setSelectedQueue(searchQueue);
    }, [facebookPage, searchQueue]);
    /** Handles closing the modal. */
    const handleClose = () => {
        setSelectedQueue(undefined);
        setPageName(undefined);
        hide === null || hide === void 0 ? void 0 : hide();
    };
    /** Handles changing the name queue. */
    const handleNameChange = (event) => {
        setPageName(event.target.value);
    };
    /** Handles updating queue and name. */
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!facebookPage)
            return;
        try {
            yield updateFacebook({
                pageId: facebookPage.id,
                queueId: (selectedQueue === null || selectedQueue === void 0 ? void 0 : selectedQueue.id) || facebookPage.queue_id,
                name: pageName || facebookPage.name,
            }).unwrap();
            notify({
                title: 'Queue successfully updated',
                time: 3000,
            }, NotificationType.Success);
            handleClose();
        }
        catch (_a) {
            notify({
                title: 'An error occured while updating the queue',
            }, NotificationType.Error);
        }
    });
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleClose, className: styles.modal }, { children: [_jsx(ModalHead, { title: "Edit Facebook page", onClose: handleClose }), _jsx(ModalBody, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "400" }, { children: [_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "200" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "Name" })), _jsx(InputText, { value: pageName, onChange: handleNameChange })] })), _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "200" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "Queue for incoming conversations" })), _jsx(QueueSelect, { selectedQueue: selectedQueue, onSelect: ({ name, id }) => setSelectedQueue({ name, id }) })] }))] })) }), _jsx(ModalFoot, { cancelOnClick: handleClose, confirmName: "Update", confirmOnClick: handleConfirm, confirmProps: {
                    disabled: (!selectedQueue || selectedQueue.id === (facebookPage === null || facebookPage === void 0 ? void 0 : facebookPage.queue_id)) &&
                        (!pageName || pageName === (facebookPage === null || facebookPage === void 0 ? void 0 : facebookPage.name)),
                    isLoading,
                } })] })));
});
